import { LabeledValue } from 'antd/lib/select';
import { getAdminAllStudio, getGames } from '../../api';
import { wrapRequestArea } from '../../lib/http/lib';

export const getStudioOptions = async (site?: string) => {
  const res = await wrapRequestArea(() => getAdminAllStudio(), site);
  if (res) {
    const list: LabeledValue[] = [];
    res.forEach((item) => {
      list.push({
        label: item.Name,
        value: item.StudioID,
      });
    });
    return list;
  }

  return [];
};

export const getGamesOptions = async (studioID: string) => {
  const res = await getGames(studioID);
  if (res) {
    const list: LabeledValue[] = [];
    res.forEach((item) => {
      list.push({
        label: item.Name,
        value: item.GameID,
      });
    });
    return list;
  }

  return [];
};
